"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.normalizeDocumentNode = exports.updateHeaders = void 0;
const updateHeaders = (contextHeaders, options) => {
    var _a;
    const headers = Object.assign(Object.assign({ 
        // default federation header
        'X-API-Version': `federation` }, contextHeaders), (((_a = options === null || options === void 0 ? void 0 : options.context) === null || _a === void 0 ? void 0 : _a.headers) || {}));
    return Object.assign(Object.assign({}, options), { context: Object.assign(Object.assign({}, ((options === null || options === void 0 ? void 0 : options.context) || {})), { headers }) });
};
exports.updateHeaders = updateHeaders;
const uniqFragments = (defs) => {
    const keysSet = new Set();
    const newDefs = [];
    for (const def of defs) {
        if (def.kind !== 'FragmentDefinition') {
            newDefs.push(def);
            continue;
        }
        if (keysSet.has(def.name))
            continue;
        newDefs.push(def);
        keysSet.add(def.name);
    }
    keysSet.clear();
    return newDefs;
};
const normalizeDocumentNode = (doc) => {
    if ('__normalized' in doc)
        return doc;
    return Object.assign(doc, {
        __normalized: true,
        definitions: uniqFragments(doc.definitions),
    });
};
exports.normalizeDocumentNode = normalizeDocumentNode;
//# sourceMappingURL=query.utils.js.map